export default "__VITE_ASSET__DgBFWN5B__"